<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="订单号">
            {{ result.registrationNo }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="学员姓名">
            {{ result.realName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="学员电话">
            {{ result.mobilePhone }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="购买课程">
            {{ result.courseName }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="课程类型">
            {{ result.courseCategoryName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="所属机构">
            {{ result.agencyName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="下单时间">
            {{ $time(Number(result.createTime)).format('YYYY/MM/DD HH:mm:ss') }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>支付信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="支付金额">
            {{ untils.money(result.payAmount) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="支付状态">
            {{ registrationStatusList.filter(v => v.value === result.registrationStatus).map(v=>v.label).join() }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="支付时间">
            {{ $time(Number(result.payAt)).format('YYYY/MM/DD HH:mm:ss') }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="是否退款">
            <status :props="result.isRefund">
              {{ result.isRefund === types.IS_REFUND ? '否' : '是' }}
            </status>
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="学员使用优惠券金额">
            {{ untils.money(result.couponAmount) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="机构是否使用课程抵用券">
            <status :props="result.isUseCoursePointsProduct ">
              {{ result.isUseCoursePointsProduct === types.IS_REFUND ? '否' : '是' }}
            </status>
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>分销列表</form-title>
    <data-table
      :data="result.distributionList"
      :table-column="tableColumn1"
    />
    <form-title>视频审核列表</form-title>
    <data-table
      :data="result.videoList"
      :table-column="tableColumn2"
      @buttonClick="buttonClick"
    />
    <form-title>视频考试列表</form-title>
    <data-table
      :data="result.videoExamList"
      :table-column="tableColumn4"
      @buttonClick="buttonClick"
    />
    <form-title>补考费用列表</form-title>
    <data-table
      :data="result.examPaymentList"
      :table-column="tableColumn3"
    />
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activeVideoItem"
    />
    <orderVideoExamChapterDialog
      :id="activeExamVideoItem.id"
      :exam-course-id="activeExamVideoItem.examCourseId"
      :exam-course-chapter-id="activeExamVideoItem.examCourseChapterId"
      :dialog-visible.sync="orderVideoExamChapterVisible"
      @confirm="getInfo"
    />
    <uploadVideoDialog
      :video-exam-id="activeExamVideoItem.id"
      :dialog-visible.sync="orderVideoExamUploadVisible"
      @confirm="getInfo"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import untils from '@/util';
import status from '@/components/common/status.vue';
import dataTable from '@/components/common/dataTable.vue';
import axClient from '@/services';
import types, {
  registrationStatusList, DistributionTypeList, examVideoStatusList, targetTypeList,
} from '@/config';
import videoDialog from '@/components/common/videoDialog.vue';
import orderVideoExamChapterDialog from '@/components/common/orderVideoExamChapterDialog.vue';
import uploadVideoDialog from '@/components/common/uploadVideoDialog.vue';

export default {
  name: 'OrderDetails',
  components: {
    dataTable,
    formTitle,
    infoPanel,
    infoItem,
    status,
    videoDialog,
    orderVideoExamChapterDialog,
    uploadVideoDialog,
  },
  data() {
    return {
      types,
      untils,
      registrationStatusList,
      vedioVisible: false,
      orderVideoExamChapterVisible: false,
      orderVideoExamUploadVisible: false,
      activeVideoItem: {},
      activeExamVideoItem: {
        examCourseId: null,
      },
      col: 5,
      result: {
        distributionList: [],
        videoList: [],
        videoExamList: [],
      },
      tableColumn1: [
        {
          key: 'targetName',
          label: '分销对象',
          width: '200px',
          dataType: 'text',
        },
        {
          key: 'distributionAmount',
          label: '分销金额',
          dataType: 'money',
        },
        {
          key: 'extractTime',
          label: '提现时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'distributionType',
          label: '分销类型',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => DistributionTypeList.filter((item) => item.value === key),
        },
      ],
      tableColumn2: [
        {
          key: 'chapterName',
          label: '章节名称',
          dataType: 'text',
        },
        {
          key: 'auditUserName',
          label: '审核人名称',
          dataType: 'text',
        },
        {
          key: 'auditAmount',
          label: '审核金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'auditAmountExtractTime',
          label: '提现时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'examStatus',
          label: '审核状态',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => examVideoStatusList.filter((item) => item.value === key),
        },
        {
          key: 'control',
          label: '操作',
          width: '100px',
          dataType: 'component',
          renderProps: [
            {
              text: '播放视频', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      tableColumn3: [
        {
          key: 'targetType',
          label: '补考类型',
          dataType: 'function',
          renderProps: '',
          render: (key) => targetTypeList.filter((item) => item.value === key),
        },
        {
          key: 'paymentCallbackAmount',
          label: '补考支付金额',
          width: 'auto',
          dataType: 'money',
        },
      ],
      tableColumn4: [
        {
          key: 'examCourseChapterName',
          label: '章节名称',
          dataType: 'text',
        },

        {
          key: 'examScore',
          label: '考试分数',
          width: 'auto',
          unit: '分',
          dataType: 'text',
        },
        {
          key: 'examStatus',
          label: '考试状态',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => examVideoStatusList.filter((item) => item.value === key),
        },
        {
          key: 'auditFailReason',
          label: '不通过原因',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '考试生成时间',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '300px',
          dataType: 'component',
          renderProps: [
            {
              text: '播放视频', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
            {
              text: '修改视频考试章节', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '上传视频', renderKey: null, type: 'success', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      this.result = await axClient.order.getCourseRegistrationListBackend({ id: this.$route.params.orderId });
      const videoExamList = await axClient.order.videoExamList({ id: this.$route.params.orderId });
      this.$set(this.result, 'videoExamList', videoExamList);
      console.log(videoExamList);
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      console.log(type);
      switch (type) {
        case 0:
          this.openVideoDialog(item);
          break;
        case 1:
          this.changeVideoExamDialog(item);
          break;
        case 2:
          this.changeVideoUploadDialog(item);
          break;
        default:
          break;
      }
    },
    // 修改视频考试章节
    changeVideoExamDialog(item) {
      this.activeExamVideoItem = item;
      this.orderVideoExamChapterVisible = true;
    },
    // 修改上传视频窗口
    changeVideoUploadDialog(item) {
      this.activeExamVideoItem = item;
      this.orderVideoExamUploadVisible = true;
    },
    // 打开视频播放窗口
    openVideoDialog(item) {
      this.vedioVisible = true;
      this.activeVideoItem.url = item.videoUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .switch-btns {
    padding-bottom: 20px;
  }
}
</style>
